module.exports = __webpack_public_path__ + "static/media/button-play.dd08b762.svg";